import type {TemplateData} from "#template/compile-context"
import type {FundamentalLikeNode} from "#template/role-markers"
import {createFundamentalMarker} from "#template/role-markers"

export const templateLikeMarker = Symbol("TemplateLike")

export interface TemplateLikeNode extends FundamentalLikeNode<TemplateData | null> {
    readonly [templateLikeMarker]: true
}

export const templateMarker = createFundamentalMarker<TemplateLikeNode>(templateLikeMarker)
export const {isLikeNode: isTemplateLikeNode, isLikeNodeClass: isTemplateLikeNodeClass, like: templateLike} = templateMarker
